module.exports = __webpack_public_path__ + "img/filezilla-connect.19daba78.png";